<template>
	<label
		class="radio prevent-highlight-mobile"
		:class="{ disabled, 'radio--rectangle': type === 'rectangle' }"
	>
		<input
			:id="id"
			:disabled="disabled"
			:value="value"
			:name="name"
			:checked="value === checkedValue"
			type="radio"
			@change="change"
		/>
		<label class="radio-bullet" :for="id" :class="{ disabled }" />
		<label v-if="label" :for="id" class="radio-label" :class="{ disabled }">
			{{ label }}
		</label>
		<slot />
	</label>
</template>

<script>
export default {
	name: 'CustomRadioButton',

	props: {
		id: {
			type: [String, Number],
			default: ''
		},
		checkedValue: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'circle',
			validator: value => {
				return ['circle', 'rectangle'].includes(value)
			}
		}
	},

	methods: {
		change(event) {
			this.$emit('change', event.target.value)
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.radio {
	display: inline-block;
	vertical-align: top;
	position: relative;
	overflow: hidden;

	input {
		position: absolute;
		left: -9999px;
	}

	&:not(.radio--rectangle) {
		&.inversion {
			.radio-bullet {
				border-color: #816cc2;

				&:after {
					display: block;
				}
			}

			.radio-label {
				color: #816cc2;
			}

			input:checked {
				& ~ .radio-bullet {
					border-color: #554781;

					&:after {
						display: none;
					}
				}

				& ~ .radio-label {
					color: #fff;
				}
			}
		}

		&.error {
			color: #e9576a;

			.radio-bullet {
				border-color: #e9576a;

				&:after {
					background: #e9576a;
				}
			}
		}

		&.disabled {
			opacity: 0.5;
			pointer-events: none;
			cursor: default;

			.disabled {
				opacity: 1;
				cursor: default;
			}
		}

		input {
			&:checked {
				& ~ .radio-bullet {
					border-color: #816cc2;

					&:after {
						display: block;
					}
				}

				& ~ .radio-label {
					color: #fff;
				}
			}
		}

		label {
			cursor: pointer;
		}

		.radio-bullet {
			float: left;
			width: 24px;
			height: 24px;
			margin: 0 16px 0 0;
			border: 1px solid #554781;
			border-radius: 50%;
			position: relative;

			&:after {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 16px;
				height: 16px;
				background: #816cc2;
				border-radius: 50%;
				content: '';
				display: none;
			}
		}
	}

	&--rectangle {
		width: 100%;

		.radio-bullet {
			display: none;
		}

		input {
			&:checked {
				& ~ .radio-label {
					border-color: $pink;
					background-color: $background-box;
				}
			}
		}

		.radio-label {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: $background-box;
			min-height: 54px;
			border: 1px solid $border-color;
			border-radius: 12px;
			padding: 15px 16px;
			font-size: 16px;
			transition: background-color 0.5s;
			cursor: pointer;

			@media (min-width: 1024px) {
				&:hover {
					background-color: rgba($light-blue, 0.25);
				}
			}
		}

		&.error {
			color: #e9576a;
		}

		&.disabled {
			opacity: 0.5;
			pointer-events: none;
			cursor: default;

			.disabled {
				opacity: 1;
				cursor: default;
			}
		}
	}
}

.radio-label {
	display: block;
	overflow: hidden;
}
</style>
